import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-392a93bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex justify-between w-full" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "subtitle mb-8" }, "Fırsat Bilgileri", -1))
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = { class: "ac-form-control w-full" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialName"
}, "Fırsat Adı", -1))
const _hoisted_6 = { class: "ac-form-control w-full" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialType"
}, "Fırsat Tipi", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "Lütfen Bir Fırsat Türü Seçin", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "company" }, "Şirket", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "individual" }, "Bireysel", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = { class: "ac-form-control w-full" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialCategories"
}, "Fırsat Kategorileri", -1))
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "ac-form-control" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialRating"
}, "Fırsat Açıklaması", -1))
const _hoisted_17 = { class: "ac-form-control" }
const _hoisted_18 = { class: "date-container flex w-full gap-4" }
const _hoisted_19 = { class: "w-1/3" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "third-title" }, "E-Posta", -1))
const _hoisted_21 = { class: "w-1/3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "third-title" }, "Telefon", -1))
const _hoisted_23 = { class: "w-1/3" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "third-title" }, "Web Sitesi", -1))
const _hoisted_25 = { class: "ac-form-control" }
const _hoisted_26 = { class: "reference-container w-full flex gap-4" }
const _hoisted_27 = { class: "w-full flex-col flex" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialReferrer"
}, "Keşfeden", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  disabled: "",
  value: null
}, "Lütfen Bir Kullanıcı Seçin", -1))
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "w-full flex-col flex" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "mb-4",
  for: "potentialReferrer"
}, "Aktaran Üçüncü Taraf", -1))
const _hoisted_33 = { class: "flex items-center justify-center gap-6 w-full" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "ac-primary-button text-2xl mt-8"
}, " Fırsat Oluştur ", -1))

import { ref, reactive, onBeforeMount } from "vue"
import { useGetDocs } from "@/mixins/modularFirebaseOperations"
import { getAllUsers } from "@/composables/userComposables"
import Multiselect from "vue-multiselect"
import StarPicker from "@/components/reusable/starPicker.vue"
import type { AcPotential } from "@/types/crm"
import type { ColorMetaField } from "@/types/metas"
import type { fetchedUser } from "@/types/fetchedUser"

/* 
TODO: 

- Add referrer and third party refferers
- Add potential categories

*/

// No props needed for add-only form


export default /*#__PURE__*/_defineComponent({
  __name: 'addPotentialForm',
  emits: ["potential-added", "cancel"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const potentialName = ref("")
const potentialType = ref<"company" | "individual" | null>(null)
const potentialRating = ref(0)
const potentialDescription = ref("")
const selectedPotentialCategories = ref<ColorMetaField[]>([])
const referredBy = ref<fetchedUser | null>(null)
const thirdPartyRefferer = ref("")
const { docs, isLoadingDocs } = useGetDocs("crm/jobCategories/list")
const allUsers = ref<fetchedUser[]>([])
const isLoadingUsers = ref(false)

const contact = reactive({
    title: "Genel",
    emailAddress: "",
    phoneNumber: "",
    address: "",
    website: "",
})

const savePotential = async () => {
    // Validate required fields
    if (!potentialName.value.trim()) {
        alert('Lütfen fırsat adını giriniz.')
        return
    }
    
    if (!referredBy.value) {
        alert('Lütfen keşfeden kullanıcıyı seçiniz.')
        return
    }
    
    if (!potentialType.value) {
        alert('Lütfen fırsat türünü seçiniz.')
        return
    }

    const newPotential: Partial<AcPotential> = {
        title: potentialName.value,
        type: potentialType.value,
        potentialRating: potentialRating.value,
        description: potentialDescription.value,
        contact: [contact],
        potentialCategories: selectedPotentialCategories.value,
        referredBy: referredBy.value,
        thirdPartyRefferrer: thirdPartyRefferer.value,
    }

    emit("potential-added", newPotential)
}

onBeforeMount( async () => {
    await getAllUsers(allUsers.value, isLoadingUsers)
} )


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(savePotential, ["prevent"]),
    class: "ac-main-form !border-none"
  }, [
    _createElementVNode("header", _hoisted_1, [
      _hoisted_2,
      _createVNode(StarPicker, {
        "onUpdate:pickedQuantity": _cache[0] || (_cache[0] = ($event: any) => (potentialRating.value = $event)),
        modelValue: potentialRating.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((potentialRating).value = $event)),
        maxQuantity: 5,
        pickedQuantity: potentialRating.value
      }, null, 8, ["modelValue", "pickedQuantity"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((potentialName).value = $event)),
          type: "text",
          required: "",
          class: "w-full title-field p-3",
          id: "potentialName"
        }, null, 512), [
          [_vModelText, potentialName.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((potentialType).value = $event)),
          required: "",
          class: "w-full !py-3"
        }, _hoisted_11, 512), [
          [_vModelSelect, potentialType.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createVNode(_unref(Multiselect), {
        class: "w-full border border-[var(--accent-gray-subtle)] py-4 pl-3 border-gray-200",
        modelValue: selectedPotentialCategories.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedPotentialCategories).value = $event)),
        options: _unref(docs),
        multiple: "",
        placeholder: _unref(isLoadingDocs) ? 'İş Kategorileri Yükleniyor...' : 'Lütfen Bir İş Kategorisi Seçin',
        "track-by": "id",
        "select-label": "Seçmek için tıklayın",
        "deselect-label": "Seçimi kaldırmak için tıklayın",
        "selected-label": "Seçildi",
        label: "name"
      }, {
        tag: _withCtx(({ option, remove }) => [
          _createElementVNode("div", {
            style: _normalizeStyle({backgroundColor: option.color}),
            class: "custom-option"
          }, [
            _createElementVNode("span", null, _toDisplayString(option.name), 1),
            _createElementVNode("span", {
              class: "remove-option",
              onClick: ($event: any) => (remove(option))
            }, "x", 8, _hoisted_14)
          ], 4)
        ]),
        _: 1
      }, 8, ["modelValue", "options", "placeholder"])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _hoisted_16,
      _withDirectives(_createElementVNode("textarea", {
        placeholder: "Buraya fırsatın detayları hakkında kısa bir bilgi yazabilirsiniz.",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((potentialDescription).value = $event)),
        class: "w-full p-3 h-32 resize-none"
      }, null, 512), [
        [_vModelText, potentialDescription.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _hoisted_20,
          _withDirectives(_createElementVNode("input", {
            placeholder: "ad.soyad@gmail.com",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((contact.emailAddress) = $event)),
            type: "email",
            class: "w-full p-3"
          }, null, 512), [
            [_vModelText, contact.emailAddress]
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _withDirectives(_createElementVNode("input", {
            placeholder: "0555 555 55 55",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((contact.phoneNumber) = $event)),
            type: "tel",
            class: "w-full p-3"
          }, null, 512), [
            [_vModelText, contact.phoneNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _withDirectives(_createElementVNode("input", {
            placeholder: "https://www.sirketsitesi.com",
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((contact.website) = $event)),
            type: "url",
            class: "w-full p-3"
          }, null, 512), [
            [_vModelText, contact.website]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((referredBy).value = $event)),
            required: "",
            class: "w-full !py-3"
          }, [
            _hoisted_29,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allUsers.value, (user) => {
              return (_openBlock(), _createElementBlock("option", {
                key: user.id,
                value: user
              }, _toDisplayString(user.userName), 9, _hoisted_30))
            }), 128))
          ], 512), [
            [_vModelSelect, referredBy.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_31, [
          _hoisted_32,
          _withDirectives(_createElementVNode("input", {
            placeholder: "Aktaran",
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((thirdPartyRefferer).value = $event)),
            type: "text"
          }, null, 512), [
            [_vModelText, thirdPartyRefferer.value]
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _hoisted_34,
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('cancel'))),
        class: "ac-secondary-button text-2xl mt-8"
      }, "İptal")
    ])
  ], 32))
}
}

})